import styled from "styled-components";
import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import {
  setAccessKeysState,
  resetAccessKeysState,
  setAccessKeyErrorsState,
} from "../../../../redux/reducers/accessKeyImport";
import { useTypedDispatch } from "../../../../hooks/useTypedDispatch";
import TextInput from "../../Inputs/TextInput";
import Button from "../../Button";

const Container = styled.form`
  & > p,
  label,
  b {
    font-size: 16px;
    color: var(--color-text-paragraph);
    font-family: var(--font-paragraph-default);
  }

  b {
    font-family: var(--font-paragraph-bold);
  }

  label {
    font-size: 14px;
  }

  .access-key-input button {
    width: 450px;
  }
  .access-key-input.last button {
    width: 406px;
  }

  button {
    margin-right: 12px;
  }
`;

const RowContainer = styled.div`
  display: flex;

  margin: 20px 0;

  position: relative;

  h2 {
    font-family: var(--font-paragraph-bold);
    font-size: 21px;
    color: var(--color-text-paragraph);
  }

  align-items: center;
`;

type TAccessKeyImportProps = {};

const AccessKeyImport: React.FC<TAccessKeyImportProps> = (_props) => {
  const dispatch = useTypedDispatch();
  const errors = useSelector(
    (state: any) => state.accessKeyImport.errors || []
  );

  const preventSubmitDefaultBehavior = (
    e: React.FormEvent<HTMLFormElement>
  ) => {
    e.preventDefault();
  };

  const fetchData = async () => {
    //
  };

  useEffect(() => {
    fetchData();
  }, []);

  // State for stack of access keys
  const [accessKeys, setAccessKeys] = React.useState<string[]>([""]);

  // Sync local state to Redux
  useEffect(() => {
    dispatch(setAccessKeysState(accessKeys));
  }, [accessKeys, dispatch]);

  // Reset Redux state on unmount
  useEffect(() => {
    return () => {
      dispatch(resetAccessKeysState());
    };
  }, [dispatch]);

  // Handler for input change
  const handleInputChange = (idx: number, value: string) => {
    // Remove all non-alphanumeric characters
    const sanitized = value.replace(/[^a-zA-Z0-9]/g, "");
    setAccessKeys((prev) => prev.map((k, i) => (i === idx ? sanitized : k)));
  };

  // Handler for removing a row by index
  const handleRemoveRow = (idx: number) => {
    setAccessKeys((prev) => {
      const updatedKeys = prev.filter((_, i) => i !== idx);
      // Update errors state in Redux after removing a key
      const errorsArray = updatedKeys.map((key) => key.length !== 44);
      dispatch(setAccessKeyErrorsState(errorsArray));
      return updatedKeys;
    });
  };

  // Handler for adding a new row
  const handleAddRow = () => {
    setAccessKeys((prev) => [...prev, ""]);
  };

  return (
    <Container onSubmit={preventSubmitDefaultBehavior}>
      <p>Solicite os arquivos de uma NF-e usando a chave de acesso:</p>
      {accessKeys.map((key, idx) => (
        <RowContainer key={idx}>
          <TextInput
            value={key}
            placeholder="Chave de acesso"
            className={`access-key-input${
              idx !== 0 && idx === accessKeys.length - 1 ? " last" : ""
            }`}
            onChange={(val) => handleInputChange(idx, val)}
            filled={key}
            onError={{
              hasError: !!errors[idx],
              message: "Chave NF-e inválida",
            }}
          />
          {idx === 0 && accessKeys.length === 1 ? (
            <Button
              icon="onlyIcon"
              iconType="plus"
              variant="secondary"
              onClick={handleAddRow}
            />
          ) : idx === accessKeys.length - 1 ? (
            <>
              <Button
                icon="onlyIcon"
                iconType="trash"
                variant="danger"
                onClick={() => handleRemoveRow(idx)}
              />
              <Button
                icon="onlyIcon"
                iconType="plus"
                variant="secondary"
                onClick={handleAddRow}
              />
            </>
          ) : (
            <Button
              icon="onlyIcon"
              iconType="trash"
              variant="danger"
              onClick={() => handleRemoveRow(idx)}
            />
          )}
        </RowContainer>
      ))}
    </Container>
  );
};

export default AccessKeyImport;
